import { createContext, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { dropdownData } from '../constants';

function useSearch() {
  const query = new URLSearchParams(useLocation().search);
  const [search, setSearch] = useState(() => ({
    task: query.get('task') || '',
    tool: query.get('tool') || dropdownData.A_DIGITAL_TOOL,
  }));
  return [search, setSearch];
}

const AppStoreContext = createContext({
  setLoadedSkills: () => {},
  loadedSkills: 3,
});

const AppStoreProvider = (props) => {
  const [loadedSkills, setLoadedSkills] = useState(3);
  const [search, setSearch] = useSearch();

  const value = {
    loadedSkills,
    setLoadedSkills,
    search,
    setSearch,
  };

  return <AppStoreContext.Provider value={value} {...props} />;
};

const useAppStore = () => {
  const value = useContext(AppStoreContext);
  return value;
};

export { AppStoreProvider, useAppStore };
export default AppStoreContext;
